
// This is a list of all of the file types for each brand/app type
export const brandIconMap: { [app: string]: string[] } = {
  'access': ['accdb'],
  'delve': [],
  'excel': ['csv', 'ods', 'xls', 'xlsx', 'xltx'],
  'infopath': ['xsn'],
  'office': [],
  'onedrive': [],
  'onenote': ['one', 'onepkg', 'onetoc'],
  'outlook': [],
  'powerpoint': ['odp', 'potx', 'ppsx', 'pptx'],
  'project': ['mpp', 'mpt', 'pub'],
  'sharepoint': [],
  'sway': [],
  'visio': ['vstx'],
  'word': ['docx', 'dotx', 'odt']
};